// extracted by mini-css-extract-plugin
module.exports = {"threedotsMenu":"style_threedotsMenu__3b_Gc","menu":"style_menu__3pSQi","Dropdown":"style_Dropdown__2j1UP","threeDotsIcon":"style_threeDotsIcon__39_uG"};